import { render, staticRenderFns } from "./b44.vue?vue&type=template&id=bf860708&scoped=true"
import script from "./b44.vue?vue&type=script&lang=js"
export * from "./b44.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf860708",
  null
  
)

export default component.exports